// "Enviar ao Espelho" — a composição da mensagem que carrega a nota.
//
// A LACUNA QUE ISTO FECHA (03/08/2026):
// `Notes.tsx` navegava para /mirror com `state: { noteContext: { content } }`
// desde sempre. `/mirror` renderiza `MirrorChat`, que NUNCA importou
// `useLocation` — o conteúdo da nota morria na fronteira da navegação. O botão
// carimbava `is_sent_to_mirror = true`, o rótulo virava "enviada ao Espelho",
// e nada tinha sido enviado. A chave i18n `mirror.noteContext.label` existia
// nos seis idiomas sem um único leitor no repositório inteiro.
//
// A composição mora aqui, fora do componente, porque é a única parte do fluxo
// que dá para testar de verdade sem montar as 3.500 linhas do MirrorChat — e
// é onde estava o risco real: mandar a nota SEM rótulo faria o Espelho tratar
// o texto como se o usuário tivesse acabado de digitá-lo.

/**
 * Monta o texto do turno quando há uma nota anexada.
 *
 * O resultado é ao mesmo tempo o que aparece na bolha do usuário e o que vai
 * no corpo para o mirror-chat — uma cópia só, de propósito. Divergir os dois
 * (mostrar curto, mandar longo) criaria estado invisível, e "o que exatamente
 * o Espelho recebeu?" viraria uma pergunta sem resposta na tela.
 *
 * @param label   Rótulo traduzido (`t("mirror.noteContext.label")`).
 * @param note    Conteúdo da nota. Vazio/nulo ⇒ devolve só o texto digitado.
 * @param typed   O que o usuário escreveu no compositor. Pode ser vazio:
 *                quem tocou "Enviar ao Espelho" já disse o que queria.
 */
export function composeNoteContextMessage(
  label: string,
  note: string | null | undefined,
  typed: string,
): string {
  const body = typeof note === "string" ? note.trim() : "";
  const tail = (typed || "").trim();
  if (body.length === 0) return typed;
  return `${label}\n${body}\n\n${tail}`.trim();
}
